var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContainer',{attrs:{"id":"user-applications"}},[_c('VRow',[_c('VCol',[_c('Submitted',{attrs:{"submitted-for":"me","mode":"embedded"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }